import { StyleSheet } from 'react-native';
import { GAME_LB_COLORS } from './GameLeaderboardSheet.constants';

export const gameLeaderboardTrophyStyles = StyleSheet.create({
  button: {
    width: 42,
    height: 42,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: GAME_LB_COLORS.trophyBg,
    borderWidth: 1.5,
    borderColor: GAME_LB_COLORS.trophyBorder,
  },
  pressed: {
    opacity: 0.7,
  },
});
